import React from "react";
import ReactDOM from "react-dom";
import AgencyVerification from "./AgencyVerification.jsx";

const safeParse = (str, fallback = {}) => {
  if (!str) return fallback;
  try {
    return JSON.parse(str);
  } catch {
    return fallback;
  }
};

export function renderAgencyVerifications() {
  document.querySelectorAll(".js-agency-verification").forEach((mount, i) => {
    if (mount.dataset.mounted === "true") return;

    const bannerProps = safeParse(mount.dataset.bannerProps);
    const paginationProps = safeParse(mount.dataset.paginationProps);

    if (!window.grecaptcha) {
      const script = document.createElement("script");
      // Site Key owned by Stewart Title
      // As of August 2025, was not configured to work with localhost requests
      // so this will never submit successfully in Storybook.
      script.src =
        "https://www.google.com/recaptcha/api.js?render=6Lc8rwYaAAAAAGsJKqZhD-FjPHtuq1D56kx47AnM";
      document.body.appendChild(script);
    }
    ReactDOM.render(
      <AgencyVerification
        bannerProps={bannerProps}
        paginationProps={paginationProps}
        isAgencyVerification={true}
        key={`agency-verification-${i}`}
      />,
      mount,
    );

    mount.dataset.mounted = "true";
  });
}
